// extracted by mini-css-extract-plugin
var _1 = "webpack-components-core-Tooltip-components-TooltipArrow-TooltipArrow-module__arrow";
export { _1 as "arrow" }
